
import pdf from 'vue-pdf';
import AdsApi from '../../libs/ads-request/ads-api';
import ERROR_MESSAGES from '../../libs/errorMessages';

export default {
  name: 'ShowPdf',
  components: {
    pdf,
  },
  data: () => ({
    orderIdDms: '',
    base64: '',
    show: false,
    loadError: '',
  }),
  computed: {
    mobile() {
      return this.$q.screen.lt.md;
    },
  },
  mounted() {
    this.initialCharge();
  },
  methods: {
    getInvoicePdf() {
      this.loaderShow('Obteniendo PDF');
      this.loadError = '';

      AdsApi.getInvoiceParams(this.orderIdDms)
        .then((response) => {
          const { data } = response;

          this.base64 = `data:application/pdf;base64,${encodeURI(data.pdfFile)}`;

          this.show = true;
        })
        .catch(() => {
          this.loadError = ERROR_MESSAGES.LOAD_INFO;
        })
        .then(this.loaderHide);
    },
    initialCharge() {
      this.orderIdDms = this.$route.params.orderIdDms;
      this.getInvoicePdf();
    },
  },
};
